export enum SMARTApp {
  PACS = 'PACS',
}

export interface LaunchMetadata {
  smartAppUrl: string;
}

export enum SMARTAppStatus {
  Success = 'Success',
  Failure = 'Failure',
}
